import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core'

/**
 * @internal
 */
@Directive({
  selector: '[gpeiPaginationItem]',
  exportAs: 'gpeiPaginationItem',
  standalone: true
})
export class PaginationItemDirective {

  /**
   * Disable the button
   */
  @Input() disabled = false

  /**
   * Set as the active page
   */
  @Input() active = false

  /**
   * The page number that will be visited when clicked
   */
  @Input() page!: number

  @Input() pageSize!: number

  /**
   * The event emitted when the page is selected
   */
  @Output() pageSelected: EventEmitter<number> = new EventEmitter()

  /**
   * Event triggered when the button in the component has been clicked. It will emit
   * the components page number via the pageSelected output
   */
  @HostListener('click')
  onButtonClick(): void {
    if (!this.disabled) {
      this.pageSelected.emit(this.page)
    }
  }

  /**
   * A collection of classes that are conditionally applied based on the active or
   * disabled status of the component
   */
  @HostBinding('class')
  private get _hostClass(): Array<string> {
    let classes = [ 'page-item' ]

    if (this.active) {
      classes.push('active')
    }

    if (this.disabled) {
      classes.push('disabled')
    }

    return classes
  }
}
